import { Component, OnInit, Inject, Renderer2, ElementRef } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { ShortObject } from 'projects/app-misc/src/app/modules/project-misc/data/project/short-json-object';
import { MatSnackBar } from '@angular/material/snack-bar';
import { TrelloService } from 'projects/app-misc/src/app/modules/trello-misc/data/trello.service';
import { timer } from 'rxjs';
import { Task } from 'projects/desktop/src/app/modules/home-page/data/tasks/task';
import { TasksService } from 'projects/desktop/src/app/modules/home-page/data/tasks/tasks.service';
import { ShortOrderItem } from 'projects/desktop/src/app/modules/home-page/data/tasks/short-order-item';
import { TrelloCheckItem } from 'projects/app-misc/src/app/modules/trello-misc/data/trello-check-item';
import { MiscSnackBarService } from 'projects/core/src/lib/misc/view/snackbar/misc-snackbar.service';

@Component({
    selector: 'app-edit-work-order-items',
    templateUrl: './edit-work-order-items.component.html',
    styleUrls: ['./edit-work-order-items.component.scss']
})
export class EditWorkOrderItemsComponent implements OnInit {
    shortItems: ShortOrderItem[];
    selectedShortItems: ShortOrderItem[] = [];

    temporaryId: number;

    // temporaryProject: Project;

    loadingSpinner = false;

    buttonLabel: string;

    orderMap = new Map();

    showItems = false;

    projectName: string;

    keyUpListener = null;


    constructor(
        private snackBarService: MiscSnackBarService,
        protected dialog: MatDialog,
        protected dialogRef: MatDialogRef<EditWorkOrderItemsComponent>,
        protected el: ElementRef,
        protected tasksService: TasksService,
        protected trelloService: TrelloService,
        protected renderer: Renderer2,
        @Inject(MAT_DIALOG_DATA) public data: {
            taskId: number,
            projectId: number,
            projectName: string,
            orderItemsId: number[]
        }
    ) {
        this.data.orderItemsId.forEach(item => {
            this.orderMap.set(item, item)
        })
        this.projectName = this.data.projectName
    }

    ngOnInit() {
        this.getItems();
    }

    getPunchItems() {
        if (this.data.taskId) {
            return this.trelloService.getAvailablePunchItems(this.data.projectId, this.data.taskId);
        } else {
            return this.trelloService.getAllPunchItems(this.data.projectId);
        }
    }

    getItems() {
        this.getPunchItems().subscribe(shortItems => {
            this.shortItems = shortItems

            if (this.data.orderItemsId) {
                shortItems.forEach(item => {
                    if (this.orderMap.has(item.id)) {
                        this.selectedShortItems.push(item)
                    }
                })
            }
            else {
                this.selectedShortItems = [];
            }

            this.showItems = true;

            const doneItems = (this.el.nativeElement as HTMLElement).getElementsByClassName('ready-punch-item')

            timer(1).subscribe(emit => {

                for (let i = 0; i < doneItems.length; i++) {
                    doneItems.item(i).parentElement.classList.add('ready-punch-item-line')
                }
            })

            this.dropDownIsShown();
        })
    }



    dropDownIsShown() {
        const elems = (this.el.nativeElement as HTMLElement).getElementsByClassName('p-list-box-block');

        const allMats = [...this.shortItems];


        timer(1).subscribe(emit => {
            const inputs = elems[0].getElementsByClassName('p-inputtext')

            this.keyUpListener = (event) => {
                const val = (inputs[0] as HTMLInputElement).value.toLowerCase();
                if (val) {
                    this.shortItems = allMats.filter(mat => {
                        const name = mat.name.toLowerCase();
                        return name.includes(val)
                    });
                }
                else {
                    this.shortItems = allMats
                }
            }

            inputs[0].addEventListener('keyup', this.keyUpListener);

            // timer(5000).subscribe(emit2 => {
            // 	inputs[1].removeEventListener('keyup', this.keyUpListener);
            // })
        })

    }

    saveOrder() {
        this.loadingSpinner = true;

        const tempTask = new Task();
        tempTask.id = this.data.taskId;
        tempTask.checkitemIds = this.selectedShortItems.map(it => it.id);
        tempTask.checkitems = this.selectedShortItems.map(it => {
                const checkItem = new TrelloCheckItem();
                checkItem.id = it.id;
                checkItem.name = it.name;
                return checkItem;
        });

        if (tempTask.id) {
            this.tasksService.updateWorkOrder(tempTask).subscribe(task => {
                task.checkitemIds = this.selectedShortItems.map(it => it.id);
                this.dialogRef.close(task);
            }, error => {
                this.loadingSpinner = false;
                this.snackBarService.openErrorSnackBar(error.message)
            })
        }
        else {
            this.dialogRef.close(tempTask);
        }

    }

    closeDialog() {
        this.dialogRef.close('close-button');
    }


    changePhoto() {

    }
}
